import { Actions } from '~/Actions';
import { INIT_GACHA_BANNERS, UPDATE_ACCOUNT_STATE, UPDATE_ANIMATION_STATE, UPDATE_TRANSACTION } from '~/Actions/ActionGachaBanner';
import { prepareMysteryBundlesForState } from '~/Layouts/GachaBanner/utils/rewards';
import { GachaAccountState } from '~/types/gacha';
import { MercatorMysteryContentState } from '~/types/mercator';

export interface GachaState {
    banners: Nullable<MercatorMysteryContentState>;
    accountState: Nullable<GachaAccountState>;
    ts: number;
    activeTransactions: Record<string, string>;
    isStartedAnimation: boolean;
}

export const initialState: GachaState = {
    banners: null,
    activeTransactions: {},
    isStartedAnimation: false,
    accountState: {},
    ts: 0,
};

const ReducerGacha = (state: GachaState = initialState, action: Actions) => {
    switch (action.type) {
        case INIT_GACHA_BANNERS:
            return {
                ...state,
                banners: prepareMysteryBundlesForState(action.payload),
            };

        case UPDATE_ACCOUNT_STATE:
            return {
                ...state,
                accountState: action.payload.state,
                ts: action.payload.ts,
            };

        case UPDATE_TRANSACTION:
            const activeTransactions = { ...state.activeTransactions };
            activeTransactions[action.bundleName] = action.transactionId;

            return {
                ...state,
                activeTransactions,
            };

        case UPDATE_ANIMATION_STATE:
            return {
                ...state,
                isStartedAnimation: action.isStarted,
            };

        default: {
            return { ...state };
        }
    }
};

export default ReducerGacha;
